import {
    DEALERDSRLIST_FAILED,
    DEALERDSRLIST_SUCCESS,
    RESET_DEALERDSRLIST,
    LOADING_DEALERDSRLIST,
    NETWORK_ERROR_DEALERDSRLIST
} from '../types/index'

import { dealerServices } from "../../config/axios";
const resetDealerDsrList = () => {
    return { type: RESET_DEALERDSRLIST };
};

const dealerDsrList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERDSRLIST });
    await dealerServices
        .post("dsrList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerDsrListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerDsrListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERDSRLIST,
                payload: err
            });
        });
};

function dealerDsrListsuccess(data) {
    return {
        type: DEALERDSRLIST_SUCCESS,
        payload: data
    };
}
function dealerDsrListFailed(data) {
    return {
        type: DEALERDSRLIST_FAILED,
        payload: data
    };
}
export { resetDealerDsrList, dealerDsrList }